import Layout2 from '@/layout/Layout2'
let ja = require('../../common/lang/ja')
let zh = require('../../common/lang/zh-CN')

export default [{
  path: '/dashboard',
  component: Layout2,
  children: [{
    path: '',
    name: 'dashboard',
    component: () => import( /* webpackChunkName: "jp.dashboard" */ '@/merchanAdmin/dashboard/dashboard'),
    meta: { zhtitle: zh.m.router.common.INDEX, jatitle: ja.m.router.common.INDEX }
  }
]
}]